import {Component, Input, OnInit} from '@angular/core';
import {NavParams} from '@ionic/angular';

import {ConfigService} from 'src/app/services/config/config.service';
import {EventsService} from 'src/app/services/event/event.service';
import {Navigator} from 'src/app/components/menu/navigator';
import {LogoutService} from 'src/app/services/logout/logout.service';
import {UserSessionService} from 'src/app/services/user-session/user-session.service';
import type { CustomerModel } from 'src/app/models/customer-model';

@Component({
  selector: 'app-invalid-kyc',
  templateUrl: './invalid-kyc.component.html',
  styleUrls: ['./invalid-kyc.component.scss'],
})
export class InvalidKycComponent implements OnInit {
  @Input() allKYCAttemptsUsed: boolean;
  @Input() set kyc_attempts(value: number) {
    if( typeof value === 'number') {
      this.kycAttemptsLeft = this.maxAttempts - value;
      const allKYCAttemptsUsed = this.navParams.get('allAttemptsUsed');
      this.kycAttemptsLeft === 0 || allKYCAttemptsUsed ? this.allKYCAttemptsUsed = true : this.allKYCAttemptsUsed = false;

    }
  }

  public environmentName: string;
  public feautureCustomerSupportURL: string;
  public kycFatal: boolean = false;
  public KYC_FAIL_SSN: boolean = false;
  public KYC_FAIL_ADDRESS: boolean = false;
  public KYC_FAIL_DOB: boolean = false;
  customer:CustomerModel;
  kycAttemptsLeft: number;

  private maxAttempts:number
  constructor(
    public events: EventsService,
    public config: ConfigService,
    public navParams: NavParams,
    public logoutService: LogoutService,
    public navigator: Navigator,
    private userSessionService: UserSessionService
  ) {
    this.maxAttempts = this.config.getConfig().FEATURE_KYC_MAX_ATTEMPTS || 3;
    this.userSessionService.getCustomer()
    .subscribe((customer)=>{
      if(customer) {
        this.customer = customer;
        if(typeof this.customer.kyc_attempts === 'number') {
          this.kycAttemptsLeft = this.maxAttempts - this.customer.kyc_attempts;
        }
      }
    });
  }

  ngOnInit() {
    this.checkKYCFailErrors();
    this.feautureCustomerSupportURL =
      this.config.getConfig().FEATURE_CUSTOMER_SUPPORT_URL ?? '';
  }

  public onClick(): any {
    return this.navigator.navigateTo(
      'SignupStepTwoComponent',
      {},
      {kycFailProcess: true}
    );
  }

  ionViewDidEnter() {
    this.events.publish('event:lobby:hide');
  }

  checkKYCFailErrors() {
    const kycFailErrors = this.navParams.get('kycFailErrors');
    if (kycFailErrors && kycFailErrors.length > 0) {
      kycFailErrors.forEach(element => {
        // check PLAYER_IS_DECEASED, PLAYER_IS_ON_COPPA_ALERT
        if (
          element.toUpperCase() == 'PLAYER_IS_DECEASED' ||
          element.toUpperCase() == 'PLAYER_IS_ON_COPPA_ALERT'
        )
          return (this.kycFatal = true);
        if (element.toUpperCase() == 'SSN_MISMATCH') this.KYC_FAIL_SSN = true;
        if (
          element.toUpperCase() == 'ADDRESS_MISMATCH' ||
          element.toUpperCase() == 'ADDRESS_IS_PO_BOX'
        )
          this.KYC_FAIL_ADDRESS = true;
        if (element.toUpperCase() == 'DATE_MONTH_YEAR_MISMATCH')
          this.KYC_FAIL_DOB = true;
        return;
      });
    }
  }

  closeModal = () => {
    //this.navigator.navigateTo("LogoutPage", { forceModal: true }, {reason:'QUALIFICATION_KYC_FAIL'});
    this.checkAndLogout();
    this.navigator.dismissAll();
    this.logoutService.onLogout();
  };

  onUploadBtnClicked = () => {
    //this.checkAndLogout();
    this.navigator.navigateTo(
      'UploadDocumentComponent',
      {forceModal: true},
      {kycFail: true}
    );
  };

  private checkAndLogout(): any {
    return this.events.publish('event:appInit:next');
  }
}
